module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }